<div class="inner" layout-vertical>
  <div layout layout-full-width layout-space-between>
    <div layout-vertical layout-full-width>
      <div layout layout-space-between layout-align-items-center>
        <rt-heading class="heading" variant="large-xx">
          <rt-icon
            *ngIf="icon"
            [name]="icon"
            [size]="iconSize"
            [class.margin-around]="iconMarginLeft"
            [class.margin-facing-text]="!iconMarginLeft"
          >
          </rt-icon>
          {{ heading }}
          <rt-icon-help *ngIf="hint" [rtTooltip]="hint" [rtTooltipPosition]="'right'">
          </rt-icon-help>
          <ng-container *ngTemplateOutlet="badge"></ng-container>
        </rt-heading>
        <span>{{ stepText }}</span>
      </div>
      <div *ngIf="subheading" class="subheading">
        <div [innerHTML]="subheading"></div>
      </div>
    </div>
    <div class="actions">
      <ng-container *ngTemplateOutlet="actionsSlot"></ng-container>
      <ng-content select="rt-icon-button, rt-button"></ng-content>
    </div>
  </div>
  <div layout layout-full-width>
    <ng-content></ng-content>
  </div>
</div>
<ng-content select="rt-tabs"></ng-content>
<rt-divider *ngIf="hasDivider"></rt-divider>
